var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuration = function SvgDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.6 75.4c-13.9-14-32.8-21.8-52.6-21.8V128l-52.6 52.6c29 29 76.1 29 105.3 0 29-29 29-76 0-105-.1-.1-.1-.1-.1-.2M128 4C59.6 4 4 59.6 4 128s55.6 124 124 124 124-55.6 124-124S196.4 4 128 4m0 223.2c-54.8 0-99.2-44.4-99.2-99.2S73.2 28.8 128 28.8s99.2 44.4 99.2 99.2-44.4 99.2-99.2 99.2"
  })));
};
export default SvgDuration;